const enLocale = {
  mixed: {
    default: 'Invalid field',
    required: 'The field is required',
    oneOf: 'The value must be one of: ${values}',
    notOneOf: 'The value cannot be any of: ${values}',
    notType: 'Invalid type',
  },
  string: {
    length: 'It should be exactly ${length} chars long',
    min: 'It should be at least ${min} characters long',
    max: 'Max ${max} chars',
    matches: 'Should match the following pattern: "${regex}"',
    email: 'Must be a valid e-mail address',
    url: 'Must be a valid URL',
    trim: 'Start / end cannot be whitespace',
    lowercase: 'Only lowecase letters are allowed',
    uppercase: 'Only uppercase letters are allowed',
  },
  number: {
    min: 'Min: ${min}',
    max: 'Max: ${max}',
    lessThan: 'Should be less then ${less}',
    moreThan: 'Should be more then ${more}',
    positive: 'Must be a positive number',
    negative: 'Must be a negative number',
    integer: 'It must be a whole number',
  },
  date: {
    min: 'Date must be after ${min}',
    max: 'Date must be before ${max}',
  },
  array: {
    min: 'Should contain at lest ${min} elements',
    max: 'Should not contain more then ${max} elements',
  },
}

export default enLocale
